import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SortEnum } from 'src/app/utils/enums/sort-enum';
import { CreateMemo } from 'src/app/utils/interfaces/new/create-memo.interface';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { Mailbox } from 'src/app/utils/interfaces/new/mailbox.interface';
import { Memo } from 'src/app/utils/interfaces/new/memo.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { environment } from 'src/environments/environment';
import { FiltresService } from '../filtres/filtres.service';
import { SnackbarService } from '../snackbar/snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class MemoService {

  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders()
  };

  private _wait = (ms) => new Promise(res => setTimeout(res, ms));

  constructor(
    private http: HttpClient,
    private _filtresService: FiltresService,
    private _snack: SnackbarService
  ) { }

  public async create(memo: CreateMemo): Promise<string> {
    try {
      const res = await this.http.post(`${environment.basePath}/medical/memos`, memo, this.httpOptions).toPromise();
      const id = res.body as string;
      return id;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async find(filtre: Filtres = {
    perpage: -1,
    currentPage: 1,
    sortOrder: SortEnum.ASC,
    sortBy: 'message'
  }, params: any): Promise<Paginated<Memo>> {
    try {
      this.httpOptions.headers = this._filtresService.setHeaders(filtre);
      const res = await this.http.get(`${environment.basePath}/medical/memos`, { params, ...this.httpOptions }).toPromise();
      const memos = res.body as Memo[];
      const paginated: Paginated<Memo> = {
        page: Number(res.headers.get('x-page')),
        perpage: Number(res.headers.get('x-per-page')),
        total: Number(res.headers.get('x-total')),
        objects: memos
      };
      return paginated;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async updateMemo(memo: Memo): Promise<void> {
    try {
      const res = await this.http.put(`${environment.basePath}/medical/memos/${memo.id}`, memo, this.httpOptions).toPromise();
      return;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async updateStatus(mailbox: Mailbox): Promise<void> {
    try {
      const res = await this.http.put(`${environment.basePath}/medical/memos/${mailbox.idMemo}/status`, mailbox, this.httpOptions).toPromise();
      return;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }
}
